import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { value: 'Italy' }
const _hoisted_5 = { value: 'Stato Estero' }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_attachment_uploader = _resolveComponent("attachment-uploader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Nome",
          text: "Nome"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.name) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Cognome",
          text: "Cognome"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.surname) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.surname]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Nazione di residenza",
          text: "Nazione di residenza"
        })
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.country) = $event))
      }, [
        _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$localizationService.GetLocalizedValue('Italia', 'Italia')), 1),
        _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$localizationService.GetLocalizedValue('Stato Estero', 'Stato Estero')), 1)
      ], 512), [
        [_vModelSelect, _ctx.localValue.country]
      ])
    ]),
    _createVNode(_component_attachment_uploader, {
      label: "Immagine profilo",
      canUpload: _ctx.$route.params.identifier != '0',
      modelValue: _ctx.localValue.profilePicture,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.profilePicture) = $event))
    }, null, 8, ["canUpload", "modelValue"])
  ]))
}